module.exports = "/assets/data/db6c205eccf49a3f99dbef877d164f51-G84.data.json";